	import $ from 'jquery';

	$(document).ready(() => {
	let lvl = $('.custom-select-level').find(".selected").attr("value");
	if(lvl != null){
		$(".custom-select-level .select--value").text("Level " + lvl);
		$(".custom-select-level .custom-value").val(lvl);
	}
	$(".custom-select-level .select--option").on("click",function (){
		$(".custom-select-level .select--value").text($(this).text());
		$(".custom-select-level .custom-value").val($(this).attr("value"));

		$(".course-filters__form").submit();
	});

	let cat = $('.custom-select-category').find(".selected");
	if(cat.attr("value") != null){
		$(".custom-select-category .select--value").text($(cat).text());
		$(".custom-select-category .custom-value").val($(cat).attr("value"));
	}
	$(".custom-select-category .select--option").on("click",function (){
		$(".custom-select-category .select--value").text($(this).text());
		$(".custom-select-category .custom-value").val($(this).attr("value"));

		$(".course-filters__form").submit();
	});

	})

	$(".course-filters__form").on("submit",function(e){
	e.preventDefault();
	let searchTerm = $("input.filter-select").val();
	let customCategory = $("input.custom-category").val(); 
	let customLevel = $("input.custom-level").val();
	let page = 1;
	$.ajax({
		url: tromplo.ajax_url,
		type: 'post',
		data: {
			action: 'reload_course_list',
			search : searchTerm,
			category: customCategory,
			level: customLevel,
		}
	})
		.done(response => {
			if (response['status'] === 'success') {
				if (response['html'].length) {
					$("#courses-list").html(response['html']);
					$("#courses-list").trigger("update");
				}
			}
			else {
				//addNotification(response['message'], 'error');
			}
		})
		.fail(response => {
			//addNotification('Error. Try again later.', 'error');
		});
	});

	$(".webinar-filters__form").on("click",function(e){
	e.preventDefault();
	let searchTerm = $("input.filter-select").val();
	console.log(searchTerm)
	$.ajax({
		url: tromplo.ajax_url,
		type:'post',
		data:{
		action:'reload_webinar_list',
		search: searchTerm
		}
	})
	.done(response =>{
		if(response['status'] === "success"){
		$("#webinars-list").html(response['html']);
		}
	})
	.fail(response =>{

	});

	});